/* eslint camelcase: 0 */

import { RoadmapExpertCriteria } from '@/typings/api/Roadmap/Experts/Criteria'
import { Model, createMessages } from '@/helpers/Model'


export class RoadmapBaseEventCriteriaModel extends Model<RoadmapExpertCriteria> {
  public static readonly page_title = createMessages({
    create: 'Добавить Критерий',
    edit: 'Редактировать Критерий',
    view: (data: RoadmapExpertCriteria) => 'Критерий «{name}»'
      .replace('{name}', data.display_name || '...'),
    list: 'Меры',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data: RoadmapExpertCriteria) => 'Удаление Критерия «{name}»'
      .replace('{name}', data.display_name || '...'),
    delete_all: 'Удаление выбранных критериев',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
